import * as yup from 'yup';

import { FormErrors } from '@blockpulse3/data/shared';
import {
  requiredEmailField,
  requiredNumberField,
  requiredPercentageNumberField,
  requiredStringField,
} from '@blockpulse3/web-client/forms';

import {
  ICrowdfundingFundraisingLegalSubscriberInformations,
  IFundraisingLegalSubscriberInformations,
} from './types';

export const schema = yup.object({
  email: requiredEmailField,
  name: requiredStringField,
  identificationNumber: requiredStringField,
  amount: requiredNumberField,
  admissionFees: requiredPercentageNumberField(0),
}) as yup.ObjectSchema<IFundraisingLegalSubscriberInformations>;

export const crowdfundingSchema = yup.object({
  email: requiredEmailField,
  name: requiredStringField,
  identificationNumber: requiredStringField,
  admissionFees: requiredPercentageNumberField(0),
  minimalAmount: yup
    .number()
    .nullable()
    .transform((value) => (isNaN(value) ? null : value))
    .test('min-max', FormErrors.MinimalAmountGreaterThanMaximal, (value, context) => {
      if (!value || value === 0 || !context.parent.maximalAmount) {
        return true;
      }
      return context.parent.maximalAmount >= value;
    })
    .test('min-negative', FormErrors.PositiveFormat, (value) => {
      if (!value || value === 0) {
        return true;
      }
      return value >= 0;
    })
    .when('$hardCap', ([hardCap], schema) => {
      return schema.max(hardCap, FormErrors.AmountGreaterThanHardCap);
    }),
  maximalAmount: yup
    .number()
    .nullable()
    .transform((value) => (isNaN(value) ? null : value))
    .test('max-min', FormErrors.MaximalAmountLessThanMinimal, (value, context) => {
      if (!value || value === 0 || !context.parent.minimalAmount) {
        return true;
      }
      return value >= context.parent.minimalAmount;
    })
    .test('max-negative', FormErrors.PositiveFormat, (value) => {
      if (!value || value === 0) {
        return true;
      }
      return value >= 0;
    })
    .when('$hardCap', ([hardCap], schema) => {
      return schema.max(hardCap, FormErrors.AmountGreaterThanHardCap);
    }),
}) as yup.ObjectSchema<ICrowdfundingFundraisingLegalSubscriberInformations>;
